import React from "react";
import { SectionContainer, ISectionContainerProps } from "component-library";

import "./PageWrapper.scss";

declare type PageWrapperStyles = {
  noPaddings: boolean;
  noMinHeight: boolean;
};

const defaultStyles: PageWrapperStyles = {
  noPaddings: false,
  noMinHeight: false,
};

interface IPageWrapperProps {
  children: React.ReactNode;
  header: string;
  buttons?: { text: string; onClick: () => void }[];
  styles?: Partial<PageWrapperStyles>;
  headerAsH1?: boolean;
}

export const PageWrapper: React.FC<
  React.PropsWithChildren<IPageWrapperProps>
> = (props) => {
  const { children, header, buttons = [], styles, headerAsH1 } = props;

  const wrapperStyles = { ...defaultStyles, ...styles };

  const containerProps: ISectionContainerProps = {
    header: header,
    headerAsH1: headerAsH1,
    variant: "shadowed",
    controls: buttons,
  };

  const contentContainerClasses = `
    c-page-wrapper__content
    ${wrapperStyles.noPaddings ? " no-paddings" : ""}
    ${wrapperStyles.noMinHeight ? " no-min-height" : ""}`;

  return (
    <div className="g-content-area c-page-wrapper">
      <div className="g-col-lg-12">
        <SectionContainer {...containerProps}>
          <div className={contentContainerClasses}>{children}</div>
        </SectionContainer>
      </div>
    </div>
  );
};
